module.exports = __webpack_public_path__ + "static/media/FLOW.50ecee33.svg";